export default __webpack_public_path__ + "static/media/image-cover.e9efb438.png";